import { render } from "./TranslateIn.vue?vue&type=template&id=053b0bb4"
import script from "./TranslateIn.vue?vue&type=script&lang=js"
export * from "./TranslateIn.vue?vue&type=script&lang=js"

import "./TranslateIn.vue?vue&type=style&index=0&id=053b0bb4&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__